import FetchGetDataWithAuthNEW from "../services/FetchGetDataWithAuthNEW";

export default function FechGetOneRegularReservations(club, idReservation) {

  var url = "/reservation/get_club_reservation_regular_by_id/" + club + "/" + idReservation;

  return FetchGetDataWithAuthNEW(url);
}

